import styled from 'styled-components';

export const VersionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;

export const VersionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  color: ${({ theme }) => theme.palette.text.primary};
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
`;
